/* eslint-disable react/jsx-props-no-spreading */
import { ComponentProps, FunctionComponent } from 'react';
import { Box, Typography, Colors } from '@altermaind/web/ui';

type Props = ComponentProps<typeof Box> & {
  label: string;
  variant?: 'outline' | 'solid';
  color?: keyof Colors;
  textProps?: ComponentProps<typeof Typography>;
};

export const Badge: FunctionComponent<Props> = ({
  label,
  variant = 'solid',
  color = 'primary',
  textProps,
  ...props
}) => {
  const bgColor = variant === 'solid' ? color : 'white';
  const labelColor = variant === 'solid' ? 'white' : color;
  const borderStyle =
    variant === 'solid' ? {} : { borderColor: color, borderStyle: 'solid' };

  return (
    <Box
      py='xxs'
      px='xs'
      borderRadius='l'
      width='max-content'
      {...props}
      backgroundColor={bgColor}
      {...borderStyle}
    >
      <Typography variant='p2' {...textProps} color={labelColor}>
        {label}
      </Typography>
    </Box>
  );
};
